export default {
  LOADING: 'LOADING_ACTION',
  NOT_LOADING: 'NOT_LOADING_ACTION',
}
